export default "/fonts/zenloop-regular-webfont.woff?f627db4c7e97c86edc5099468e19fc2a";